<template>
  <div class="page-wrapper">
    <search-list @findData="findData" class="mb16"></search-list>

    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <img-show :src="imgSrc" :n="showImgKey"></img-show>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {formatDateTime} from '@/utils/format'
  import {getList} from  'api/houseType'
  import ImgShow from 'components/ImgShow/index'

  export default {
    name: "project",
    components:{
      SearchList,
      TableList,
      ImgShow
    },

    data(){
      return {
        showImgKey:0,
        imgSrc:'',
        page:1,
        current: 1,
        total: 0,
        searchData: {
          page: 1,
          limit: 10
        },
        dataTable: [],
        loading: false,
        columns:[
          {
            type:'index',
            width:60,
          },

          {
            title:'房型名称',
            key:'house_type_name',
            align:'center',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    let query = {

                    };
                    this.$router.push({
                      name: 'searchHouseTypeDetail',
                      query: {houseTypeFid: params.row['house_type_id']}
                    })  //
                  }
                }
              }, params.row['house_type_name'])
            }
          },{
            title:'房型头图',
            key:'houseTypePic',
            align:'center',
             render:(h,params)=>{

                  return h('div',[
                      h('Img',{
                          attrs:{
                              src: params.row['house_type_pic'],
                          },
                          style:{
                              width: '80px',
                              height: '45px',
                              margin:'5px',
                              cursor:'pointer'
                          },
                          on:{
                              click:()=>{
                                this.showImg(params.row['house_type_pic']);
                              }
                          }
                      })
                  ])
              }

          },
          {
            title:'房型面积',
            key:'area',
            align:'center'

          },
          {
            title:'户型',
            key:'house_type_show_name',
            align:'center'
          },{
            title:'最小价格(￥/月)',
            key:'min_price',
            align:'center'
          },
          {
            title:'最大价格(￥/月)',
            key:'max_price',
            align:'center'
          },
          {
            title:'房型状态',
            key:'house_type_status_name',
            align:'center'
          },

        ],
        searched:null,
      }

    },
    methods:{

      findData(data){
        this.page=1;
        this.current=1;
        this.houseTypeList(data)
      },
      houseTypeList(data) {
      let params={
        ...data,
        page:this.page,
        limit:10
      };
        getList(params).then( res => {
          this.dataTable = res.data.rows
          this.total = res.data.total
          this.loading = false
          this.searched=params;
        })
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.houseTypeList(this.searched)

      },
      showImg(data) {
        this.imgSrc = data
        this.showImgKey++
      },

    }
  }
</script>

<style scoped>

</style>
